<template>
  <div class="smardie-attachment-card">
    <span class="smardie-attachment-card__icon" aria-hidden="true">
      <img
        v-if="thumbnail"
        class="smardie-attachment-card__thumb"
        :src="thumbnail"
        alt=""
        width="24"
      >
      <svg
        v-else
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" stroke="#4DA1FF" stroke-width="1.5" fill="#E7F5FE"/>
        <path d="M14 3v5h5" stroke="#4DA1FF" stroke-width="1.5" fill="none"/>
        <path d="M9 12h6M9 15h6M9 18h4" stroke="#4DA1FF" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </span>
    <span class="smardie-attachment-card__text">
      <span class="smardie-attachment-card__title">{{ title }}</span>
      <span v-if="subtitle" class="smardie-attachment-card__subtitle">{{ subtitle }}</span>
    </span>
    <button
      v-if="removable"
      type="button"
      class="smardie-attachment-card__remove"
      aria-label="Remove attachment"
      @click.stop="$emit('remove')"
    >
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M3 3l6 6M9 3L3 9" stroke="#4DA1FF" stroke-width="1.75" stroke-linecap="round"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AttachmentCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    thumbnail: { type: String, default: '' },
    removable: { type: Boolean, default: true }
  }
}
</script>

<style scoped>
.smardie-attachment-card {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  flex: 0 0 auto;
  min-width: 200px;
  max-width: 280px;
  margin: 0;
  padding: 12px 14px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: var(--color-bg-surface);
  gap: 12px;
}

.smardie-attachment-card__icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
}

.smardie-attachment-card__thumb {
  display: block;
  width: 24px;
  height: auto;
  max-height: 28px;
  object-fit: cover;
  border-radius: 2px;
}

.smardie-attachment-card__text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
}

.smardie-attachment-card__title {
  font-family: var(--font-semibold, inherit);
  font-weight: 600;
  font-size: 14px;
  color: var(--color-text);
  line-height: 1.3;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.smardie-attachment-card__subtitle {
  font-weight: 400;
  font-size: 14px;
  color: var(--color-mid-grey);
  line-height: 1.3;
}

.smardie-attachment-card__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  border: 1.5px solid #4DA1FF;
  border-radius: 50%;
  background: var(--color-bg-surface);
  cursor: pointer;
  color: var(--color-primary);
}

.smardie-attachment-card__remove:hover,
.smardie-attachment-card__remove:focus {
  background: var(--color-selected);
  outline: none;
}
</style>
